Object.defineProperty(exports,"__esModule",{value:true});exports.alphabeticalCompare=exports.isAlarming=exports.isUnlocked=exports.isDisarmed=exports.isYellow=exports.isRed=exports.positionStates=undefined;var _securityDeviceArmState=require('../armState/securityDeviceArmState');
var _armStateUtils=require('../armState/armStateUtils');
var _securityDeviceHealthStatus=require('../healthStatus/securityDeviceHealthStatus');



var _complianceState=require('../complianceState/complianceState');
var _types=require('../complianceState/types');
var _positionHealthStatus=require('../healthStatus/positionHealthStatus');var _positionHealthStatus2=_interopRequireDefault(_positionHealthStatus);
var _types2=require('../armState/types');function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}

var positionStates=exports.positionStates=function positionStates(position){
var device=position.getArmDevice();
var armState=(0,_securityDeviceArmState.getSecurityDeviceArmState)(device);
var healthState=(0,_positionHealthStatus2.default)(position);
var complianceState=(0,_complianceState.positionComplianceState)(position);
return{
armState:armState,
healthState:healthState,
complianceState:complianceState};

};

var isRed=exports.isRed=function isRed(armState){
if(!armState){
return false;
}

switch(armState.type){
case _types2.armState.ALARMING:
case _types2.armState.DISARMED:
return true;
default:
return false;}

};

var isYellow=exports.isYellow=function isYellow(healthState,complianceState){
if(
healthState.type===_securityDeviceHealthStatus.HealthStatus.HEALTHY&&
complianceState.type===_types.ComplianceStatus.COMPLIANT)
{
return false;
}

return true;
};

var isDisarmed=exports.isDisarmed=function isDisarmed(armState){
if(!armState){
return false;
}

return armState.type===_types2.armState.DISARMED;
};

var isUnlocked=exports.isUnlocked=function isUnlocked(armState){
if(!armState){
return false;
}

return armState.type===_types2.armState.UNLOCKED;
};

var isAlarming=exports.isAlarming=function isAlarming(armState){
if(!armState){
return false;
}

return armState.type===_types2.armState.ALARMING;
};








var alphabeticalCompare=exports.alphabeticalCompare=function alphabeticalCompare(n1,n2){
if(!n1||!n2)return 0;
var nameA=n1.toLowerCase();
var nameB=n2.toLowerCase();
if(
nameA<nameB)
{
return-1;
}
if(nameA>nameB)return 1;
return 0;
};